import { useEffect, useState } from "react";
import { toast } from "sonner";
import { History, RefreshCw } from "lucide-react";
import { NeuCard, NeuButton } from "../../components/neu/Neu";
import { broadcastHistory, broadcastResend } from "../../api/platform";
import { localDateTime } from "../../lib/datetime";

// سجل الإشعارات المرسلة: العنوان، التاريخ، عدد الشركات/المستلمين، كم قرأه، وإعادة الإرسال.
export const NotifyHistory = ({ refreshKey }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => broadcastHistory().then(setItems).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  const resend = async (id) => {
    setBusy(id);
    try { const r = await broadcastResend(id); toast.success(`أُعيد الإرسال إلى ${r.recipients} مستخدم`); load(); }
    catch { toast.error("فشلت إعادة الإرسال"); } finally { setBusy(""); }
  };
  return (
    <NeuCard data-testid="notify-history">
      <p className="label-xs flex items-center gap-2"><History className="h-4 w-4 text-primary" /> سجل الإشعارات المرسلة</p>
      {items.length ? (
        <ul className="mt-3 grid gap-2" data-testid="notify-history-list">
          {items.map((n) => (
            <li key={n.id} data-testid={`history-row-${n.id}`} className="rounded-2xl bg-background p-3 shadow-neu-sm">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-black">{n.title_ar || n.title_en}</p>
                  <p className="mt-0.5 font-mono text-[11px] text-muted-foreground" dir="ltr">{localDateTime(n.at)}</p>
                  <p className="mt-1 text-xs font-semibold text-muted-foreground" data-testid={`history-stats-${n.id}`}>
                    {n.companies} شركة · {n.recipients} مستلم · قرأه {n.read}
                  </p>
                </div>
                <NeuButton type="button" data-testid={`history-resend-${n.id}`} disabled={busy === n.id} onClick={() => resend(n.id)}>
                  <RefreshCw className={`h-3.5 w-3.5 ${busy === n.id ? "animate-spin" : ""}`} />
                </NeuButton>
              </div>
            </li>
          ))}
        </ul>
      ) : <p className="mt-3 text-sm text-muted-foreground" data-testid="notify-history-empty">لم تُرسَل أي إشعارات بعد.</p>}
    </NeuCard>
  );
};
